module.exports = __webpack_public_path__ + "static/img/guest29.86dd35d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest29.png
// module id = aWYw
// module chunks = 0